// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"modal_modalDialog__1GrJy","guideModal":"modal_guideModal__3JT_w","spanX":"modal_spanX__3smZl","modalHeader":"modal_modalHeader__1kfU3"};